<template>
  <b-container class="vh-100 d-flex align-items-center justify-content-center">
    <b-card title="비밀번호 재설정" style="max-width: 400px; width: 100%;" class="shadow">
      <b-alert show variant="info" class="small">
        초기 비밀번호를 사용 중입니다. 새 비밀번호를 설정해야 로그인이 완료됩니다.
      </b-alert>

      <b-form @submit.prevent="handlePasswordReset">
        <b-form-group label="새 비밀번호">
          <b-form-input
              v-model="form.newPassword"
              type="password"
              required
              placeholder="4자 이상 입력"
              :state="newPasswordState"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="비밀번호 확인">
          <b-form-input
              v-model="passwordConfirm"
              type="password"
              required
              placeholder="재입력"
              :state="passwordMatch"
          ></b-form-input>
          <b-form-invalid-feedback :state="passwordMatch">
            비밀번호가 일치하지 않습니다.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-button type="submit" variant="primary" block :disabled="!isFormValid" class="mt-4">
          비밀번호 변경 완료
        </b-button>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      form: {
        newPassword: '',
        // 로그인 시 임시로 저장했던 username이 필요할 수 있습니다.
        username: localStorage.getItem('tempUsername')
      },
      passwordConfirm: ''
    };
  },
  computed: {
    // 새 비밀번호 길이 검증
    newPasswordState() {
      if (this.form.newPassword.length === 0) return null;
      return this.form.newPassword.length >= 4;
    },
    // 일치 여부 검증
    passwordMatch() {
      if (this.passwordConfirm.length === 0) return null;
      return this.form.newPassword === this.passwordConfirm;
    },
    // 버튼 활성화 최종 조건
    isFormValid() {
      // 두 조건이 모두 true여야 버튼이 활성화됩니다.
      return this.newPasswordState === true && this.passwordMatch === true;
    }
  },
  methods: {
    async handlePasswordReset() {
      try {
        const res = await axios.post('/api/auth/update-password', this.form);
        if (res.status === 200) {
          alert('비밀번호 변경 성공! 다시 로그인 해주세요.');
          localStorage.clear(); // 안전을 위해 모든 세션 정보 삭제
          this.$router.push('/login');
        }
      } catch (error) {
        alert('변경 실패: ' + (error.response?.data?.message || '오류 발생'));
      }
    }
  }
}
</script>
